<upp-kb-textarea #input
    [rows]="rows"
    [kiosk]="kiosk"
    [formControl]="Control"
    [name]="name"
    [placeholder]="content"
    [readonly]="readonly"
></upp-kb-textarea>
